import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import {
  createExercise,
  editExercise,
} from "../../../api/endpoints/ExerciseEndpoints";
import { ExerciseRequest } from "../../../models/Exercise";

export default function useCreateOrEditExercise(lessonId: string) {
  return useMutation<
    { id: number },
    AxiosError,
    { exercise: ExerciseRequest; operation: "create" | "edit" }
  >({
    mutationKey: ["create-or-edit-exercise", lessonId],
    mutationFn: ({ exercise, operation }) =>
      operation === "create"
        ? createExercise(lessonId, exercise)
        : editExercise(exercise),
  });
}
